import React from 'react';
import { motion } from 'framer-motion';
import { ChefHatIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-20 pb-16 px-6 md:pt-32 md:pb-24 relative overflow-hidden" data-id="element-13">
      <div className="max-w-3xl mx-auto text-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-6" data-id="element-15">
          <div className="bg-cream-dark p-4 rounded-full shadow-warm inline-block" data-id="element-16">
            <ChefHatIcon className="w-10 h-10 text-terracotta" data-id="element-17" />
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-18">
          Convierte tu cocina en una fuente de ingresos reales con Repostería
          Casera de Guerra.
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-terracotta mb-10 font-medium" data-id="element-19">
          El sistema paso a paso para crear un negocio de postres rentable en 72
          horas, usando ingredientes básicos y sin gastar una fortuna en hornos
          profesionales.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-xl text-chocolate/80 space-y-6 text-left bg-white/50 p-6 md:p-8 rounded-2xl shadow-warm mb-10" data-id="element-20">
          <p data-id="element-21">
            ¿Tienes buena mano para los dulces pero sientes que los ingredientes
            están tan caros que es imposible ganar dinero? Lo vemos a diario:
            gente con talento que hornea con amor, pero que al final de la
            semana se da cuenta de que trabajó gratis porque no supo calcular
            sus costos o usó recetas que no dejan margen de ganancia.
          </p>
          <p data-id="element-22">
            Vender postres en una economía volátil no se trata de hacer alta
            pastelería francesa; se trata de dominar la estrategia de
            "Repostería de Guerra": máxima calidad con insumos locales y una
            ingeniería de costos blindada.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-23">
          <CTAButton href="#pricing" data-id="element-24" />
        </motion.div>
      </div>
    </section>;
}